import { api } from '@/api'

export interface ServiceCategory {
  id: string
  name: string
  slug: string
  description: string | null
  isActive: boolean
  parent: ServiceCategory | null
  parentId: string | null
  children: ServiceCategory[]
  servicesCount: number
  sortOrder: number
  createdAt: string
}

export interface ServiceCategoryOption extends ServiceCategory {
  label: string
  value: string
}

export interface ServiceCategoriesFilters {
  page?: number
  [key: string]: string | number | boolean | undefined | null
}

export interface ServiceCategoriesResponse {
  data: ServiceCategory[]
  meta: {
    message: string
    errors: unknown[]
  }
  pagination: {
    currentPage: number
    perPage: number
    total: number
    lastPage: number
    from: number | null
    to: number | null
  }
}

export function getServiceCategoriesAction(filters: ServiceCategoriesFilters = {}): Promise<ServiceCategoriesResponse> {
  const params = new URLSearchParams()

  params.append('page', String(filters.page ?? 1))

  Object.entries(filters).forEach(([key, value]) => {
    if (key !== 'page' && value !== '' && value !== null && value !== undefined) {
      params.append(`filter[${key}]`, String(value))
    }
  })

  return api.v2.get<ServiceCategoriesResponse>(`/service-category?${params.toString()}`)
}
